import template from './teamRequestCardActionsMobile.html';
import controller from './teamRequestCardActionsMobile.controller';
import './teamRequestCardActionsMobile.scss';

let teamRequestCardActionsMobileComponent = {
  restrict: 'E',
  bindings: {
    request : '<',
    onAccept : '&',
    onReject : '&',
    onDiscard : '&',
    isDisabled: '<'
  },
  template,
  controller
};

export default teamRequestCardActionsMobileComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardActionsMobile/teamRequestCardActionsMobile.component.js